module.exports = __webpack_public_path__ + "img/13.5020a252.png";